module.exports = __webpack_public_path__ + "assets/img/zf2.328ae585.png";